// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3_HF_","right":"Footer_right__3Dehn","buttons":"Footer_buttons__Vg0pl"};